import fieldIds from '../constants/field-ids';

const getFieldIdsByKey = (key) => {
  if (!key) return [];

  return Object.values(fieldIds).filter((id) => id.startsWith(key));
};

export default getFieldIdsByKey;
